import React from "react";
import {Text, TouchableOpacity, View,StyleSheet} from "react-native";
import {connect} from "react-redux";
import {compose} from "redux";
import {withTranslation} from "react-i18next";


class Tab extends React.Component{
    constructor(props) {
        super(props);
	this.onPress = this.onPress.bind(this);
    }

    onPress() {
        this.props.onItemPress(this.props.index);
        this.props.onPressCallBack(this.props.index);
    }

    render() {
        const styles = StyleSheet.create({
            container:{
              marginHorizontal:18
            },
           text : {
               fontFamily: this.props.theme.fonts.text,
               fontSize:14,
               color:(this.props.isActive) ? '#fff' :this.props.theme.colors.tertiary.black5.value
           }
        });
        return <TouchableOpacity onPress={this.onPress}>
          <View style={styles.container} ref={this.props.mref}>
            <Text style={styles.text}>{this.props.t(this.props.item.title)}</Text>
          </View>
        </TouchableOpacity>
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}
export default compose(connect(mapStateToProps),withTranslation())(Tab);


